import dayjs from 'dayjs';

import { useMemo } from 'react';

import { TabTableContainer } from 'components/layout/AppLayout/AppLayout.styled';
import DynamicList from 'components/list/DynamicList';
import { FilterAction, FilterType, ListComponents } from 'components/list/DynamicListFilterUtils';

import useRouterFilters from 'hooks/useRouterFilters';

import { ENUMS, REPORT } from 'services/consts';

import { DYNAMICLISTS } from 'utils/constants';

const ZeroDCGrouped = () => {
	const columns = useMemo(
		() => [
			{
				Header: 'zeroDC.lastRecordDate',
				accessor: 'lastRecordDate',
				filterType: FilterType.date,
				renderCell: ListComponents.DATETIME,
				width: 150,
				showOnMobile: true
			},
			{
				Header: 'ID',
				accessor: 'id',
				filterType: FilterType.number,
				show: false
			},
			{
				Header: 'originCountry',
				accessor: 'originCountry',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.COUNTRIES,
				filterPrefix: 'country.',
				renderCell: ListComponents.COUNTRY,
				width: 100,
				showOnMobile: true
			},
			{
				Header: 'originCity',
				accessor: 'originCity',
				filterType: FilterType.string,
				width: 100,
				showOnMobile: true
			},
			{
				Header: 'destinationCountry',
				accessor: 'destinationCountry',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.COUNTRIES,
				filterPrefix: 'country.',
				renderCell: ListComponents.COUNTRY,
				width: 100,
				showOnMobile: true
			},
			{
				Header: 'destinationCity',
				accessor: 'destinationCity',
				filterType: FilterType.string,
				width: 100,
				showOnMobile: true
			},
			{
				Header: 'numberOfRecords',
				accessor: 'numberOfRecords',
				filterType: FilterType.number,
				width: 50,
				showOnMobile: true
			}
		],
		[]
	);
	const defaultFilters = useMemo(
		() => [
			{
				column: columns.find((c) => c.accessor === 'lastRecordDate'),
				action: FilterAction.between,
				value: {
					start: dayjs().startOf('day').toISOString(),
					end: dayjs().endOf('day').toISOString()
				}
			}
		],
		[]
	);

	const defaultSort = useMemo(() => [{ id: 'lastRecordDate', desc: true }], []);
	const filtersFromRouter = useRouterFilters(columns);

	return (
		<TabTableContainer>
			<DynamicList
				id={DYNAMICLISTS.ZERO_DC_GROUPED_LIST}
				columns={columns}
				defaultFilters={filtersFromRouter ?? defaultFilters}
				fetchUrl={REPORT.DC.GET_ZERO_DC_GROUPED_LIST}
				exportName="zeroDCGroupedListExport"
				infiniteScroll
				defaultSort={defaultSort}
				disableInfiniteScrollUp
			/>
		</TabTableContainer>
	);
};

export default ZeroDCGrouped;
